module.exports = __webpack_public_path__ + "static/intro_graph-26256c276f5fcd6a1ae9d96b763375eb.png";